import { apiSpaceUrl } from "utils/urls";

import axios from "axios";

export const postResearch = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("research", spaceUuid), body, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return data;
};

export const patchResearch = async (spaceUuid, body) => {
    let headers = {};
    if (body.file) {
        headers = {
            "Content-Type": "multipart/form-data",
        };
    }
    const { data } = await axios.patch(apiSpaceUrl("research", spaceUuid) + "/" + body.id, body, {
        headers: headers,
    });
    return data;
};

export const getResearchList = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("research", spaceUuid), { params: params });
    return data;
};

export const getResearch = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("research", spaceUuid) + "/uuid", {
        params: params,
    });
    return data;
};

export const getResearchReference = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("referenceResearch", spaceUuid), {
        params: params,
    });
    return data;
};

export const postReferenceResearch = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("referenceResearch", spaceUuid) + "/bulk_insert", body);
    return data;
};

export const deleteReferenceResearch = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("referenceResearch", spaceUuid) + "/bulk_delete", { data: body });
    return data;
};

export const postResearchAnalysis = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("researchAnalysis", spaceUuid), body);
    return data;
};

export const patchResearchAnalysis = async (spaceUuid, body) => {
    const { data } = await axios.patch(apiSpaceUrl("researchAnalysis", spaceUuid) + "/" + body.id, body);
    return data;
};

export const getResearchAnalysis = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("researchAnalysis", spaceUuid), {
        params: params,
    });
    return data;
};

export const deleteResearchAnalysis = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("researchAnalysis", spaceUuid), { data: body });
    return data;
};

export const deleteResearch = async (spaceUuid, params) => {
    const { data } = await axios.delete(apiSpaceUrl("research", spaceUuid) + "/" + params.id);
    return data;
};

export const deleteBulkResearch = async (spaceUuid, params) => {
    const { data } = await axios.delete(apiSpaceUrl("research", spaceUuid) + "/bulk-delete", { data: params });
    return data;
};

export const citationReference = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("referenceCitation", spaceUuid), body);
    return data;
};

export const deleteReferenceCitation = async (spaceUuid, body) => {
    const { data } = await axios.delete(
        apiSpaceUrl("research", spaceUuid) + `/${body.research_uuid}/citation/bulk_delete`,
        {
            data: body,
        },
    );
    return data;
};

export const deleteReferenceCitationByUuid = async (spaceUuid, body) => {
    const { data } = await axios.delete(
        apiSpaceUrl("research", spaceUuid) + `/${body.research_uuid}/citation/delete-by-uuid`,
        {
            data: body,
        },
    );
    return data;
};

export const getResearchMedia = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("researchMedia", spaceUuid), {
        params: params,
    });
    return data;
};

export const postResearchMedia = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("researchMedia", spaceUuid), body, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return data;
};

export const deleteResearchMedia = async (spaceUuid, params) => {
    const { data } = await axios.delete(apiSpaceUrl("researchMedia", spaceUuid) + "/bulk_delete", { data: params });
    return data;
};

export const postResearchWithHtml = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("researchCreateWidthHtml", spaceUuid), body);
    return data;
};
